import React from 'react'
import { Link } from 'react-router-dom'
import { useCart } from '../context/CartContext'

function Navigation() {
  const { getCartCount } = useCart()

  return (
    <header className="header">
      <nav className="nav container">
        <div className="logo">
          <Link to="/" style={{ color: 'white', textDecoration: 'none' }}>ShopCloud</Link>
        </div>
        <ul className="nav-links">
          <li><Link to="/">Home</Link></li>
          <li><Link to="/products">Products</Link></li>
          <li>
            <Link to="/cart">
              Cart {getCartCount() > 0 && <span className="cart-count">({getCartCount()})</span>}
            </Link>
          </li>
          <li><Link to="/admin">Admin</Link></li>
        </ul>
      </nav>
    </header>
  )
}

export default Navigation
